import { get, getPublic, post, put, putPublic, del } from "../../data/api";

// ---------------------------------------------------------------------------
// Locataire (acces anonyme par jeton, lien recu par mail a la fin de la location)
// ---------------------------------------------------------------------------

export async function getPublicSurvey(token) {
    return await getPublic(`public/satisfaction/${token}`);
}

// Sauvegarde en arriere-plan : une liste de { questionPublicId, valueNumber, valueText }.
export async function savePublicAnswers(token, answers) {
    return await putPublic(answers, `public/satisfaction/${token}/answers`);
}

export async function completePublicSurvey(token, answers = []) {
    return await putPublic(answers, `public/satisfaction/${token}/complete`);
}

// Envoi "au dernier moment" (fermeture de l'onglet, passage en arriere-plan) :
// sendBeacon survit a la fermeture de la page, contrairement a fetch.
export function beaconPublicAnswers(token, answers) {
    if (!answers || answers.length === 0) {
        return false;
    }

    try {
        if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
            const blob = new Blob([JSON.stringify(answers)], { type: "application/json" });
            return navigator.sendBeacon(`/api/public/satisfaction/${token}/answers`, blob);
        }
    } catch {
        // ignore : la sauvegarde classique reprendra a la prochaine modification
    }

    return false;
}

// ---------------------------------------------------------------------------
// Loueur : questions de ses outils
// ---------------------------------------------------------------------------

export async function getToolSatisfactionQuestions(toolId) {
    return await get(`satisfaction/tools/${toolId}/questions`);
}

export async function addToolQuestion(toolId, input) {
    return await post(input, `satisfaction/tools/${toolId}/questions`);
}

export async function updateQuestion(publicId, input) {
    return await put(input, `satisfaction/questions/${publicId}`);
}

export async function deleteQuestion(publicId) {
    return await del(`satisfaction/questions/${publicId}`);
}

export async function reorderToolQuestions(toolId, publicIds) {
    return await put(publicIds, `satisfaction/tools/${toolId}/questions/reorder`);
}

export async function generateToolQuestions(toolId, ia = false) {
    return await post({}, `satisfaction/tools/${toolId}/questions/generate?ia=${ia ? "true" : "false"}`);
}

// ---------------------------------------------------------------------------
// Loueur : resultats
// ---------------------------------------------------------------------------

export async function getToolSatisfactionStats(toolId) {
    return await get(`satisfaction/tools/${toolId}/stats`);
}

export async function getSatisfactionDashboard(start, end) {
    return await get(`satisfaction/dashboard/${start}/${end}`);
}

export async function getRentalSurvey(rentalId) {
    return await get(`satisfaction/rental/${rentalId}`);
}

export async function sendRentalSurvey(rentalId) {
    return await put({}, `satisfaction/rental/${rentalId}/send`);
}

export async function getClientSatisfaction(clientId) {
    return await get(`satisfaction/client/${clientId}`);
}

// ---------------------------------------------------------------------------
// Libelles partages
// ---------------------------------------------------------------------------

export const QUESTION_TYPES = [
    { label: "Note de 1 à 5", value: "Rating" },
    { label: "Oui / Non", value: "YesNo" },
    { label: "Choix unique", value: "Choice" },
    { label: "Texte libre", value: "Text" }
];

export function questionTypeLabel(type) {
    return QUESTION_TYPES.find((item) => item.value === type)?.label ?? type;
}

export function surveyStatusLabel(status) {
    const labels = {
        NotSent: "Non envoyé",
        Sent: "Envoyé, en attente",
        Started: "Commencé",
        Completed: "Terminé"
    };
    return labels[status] ?? status ?? "";
}
